<template>
  <section class="contact-site">
    <div
      :class="popinMode ? 'contact-site__form--popin' : 'contact-site__form'"
    >
      <div class="contact-site__form__row">
        <contact-shared-form
          h2
          :error="$v.form"
          :list="listStatus"
          :is-horizontal="true"
          @updateSelecterInputs="updatedSelecter"
        />

        <contact-shared-form
          h2
          :error="$v.form"
          :list="listIndividual"
          :is-horizontal="true"
          @updateInputs="updatedInputs"
          @updateDateInputs="updatedDateInputs"
          @updateSelecterInputs="updatedSelecter"
          @updateRadioButton="updatedRadioButton"
        />
      </div>
      <div class="contact-site__form__row">
        <contact-agency
          h2
          :error="$v.form"
          @updateInputs="updatedAgency"
          :is-horizontal="true"
          :business="business"
          @updateDateInputs="updatedDateInputs"
          @updateSelecterInputs="updatedSelecter"
          @updateRadioButton="updatedRadioButton"
        />
        <contact-shared-form
          h2
          :error="$v.form"
          :list="listMessage"
          :is-horizontal="false"
          @updateInputs="updatedInputs"
          @updateDateInputs="updatedDateInputs"
          @updateSelecterInputs="updatedSelecter"
          @updateRadioButton="updatedRadioButton"
        />
      </div>
    </div>
    <div class="contact-site__form__complementary">
      <complementary-info
        h2
        :btn-is-visibile="false"
        :errors="$v.form"
        @updatedRadioButton="updatedRadioButton"
      />
    </div>
    <ul class="contact-site__form__button">
      <li>
        <span>*Champs obligatoires</span>
      </li>
      <li>
        <rent-button
          :loading="isLoading && !isSubmitted"
          @buttonclicked="submitForm()"
          :disabled="isSubmitted"
        >
          {{ $t('commons.continue') }}
        </rent-button>
      </li>
    </ul>

    <confidentiality />
  </section>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import {
  required,
  minLength,
  numeric,
  maxLength,
} from 'vuelidate/lib/validators'
import ContactSharedForm from './ContactSharedForm'
//import ContactAgency from './ContactAgency'
import ComplementaryInfo from '../shared/inputs/ComplementaryInfo/ComplementaryInfo'
import Confidentiality from '../shared/inputs/ComplementaryInfo/Confidentiality'
import RentButton from '../shared/RentButton'

import status from '../../../data/forms/contact/status.json'
import individual from '../../../data/forms/contact/individual.json'
import message from '../../../data/forms/contact/message.json'

export default {
  components: {
    ContactAgency: () => import(/* webpackChunkName: "contact"  */ `./ContactAgency`),
    ContactSharedForm,
    ComplementaryInfo,
    RentButton,
    Confidentiality,
  },
  props: {
    popinMode: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      listStatus: status,
      listIndividual: individual,
      listMessage: message,
      isLoading: false,
      errors: {},
      form: {
        contact_type: 2,
        light: 1,
        status: 1,
        civility: null,
        email: null,
        first_name: null,
        last_name: null,
        phone: null,
        request_type: null,
        message: null,
        business_id: window.localStorage.rentPickupBusinessId,
        optin_email: null,
        optin_sms: null,
        postal_code: null,
        renault_campaign: window.renaultRent?.sessions?.campaign,
        renault_context: window.renaultRent?.sessions?.context,
        renault_origin: window.renaultRent?.sessions?.origin,

      },
      request_value: null,
    }
  },
  validations: {
    form: {
      civility: { required },
      email: { required },
      first_name: { required, minLength: minLength(2) },
      last_name: { required, minLength: minLength(2) },
      phone: {
        minLength: minLength(10),
        numeric,
        maxLength: maxLength(10),
        required,
      },
      request_type: { required },
      status: { required },
      message: { required },
      business_id: { required },
      optin_email: { required },
      optin_sms: { required },
      postal_code: { },
      renault_campaign: {},
      renault_context: {},
      renault_origin: {},
    },
  },
  computed: {
    ...mapState({
      isSubmitted: (state) => state.contact.isSubmitted,
      userDetails: (state) => state.user.details,
    }),
    ...mapGetters({
      userIsLogged: 'auth/userIsLogged',
    }),
  },
  watch: {
    userDetails: {
      handler() {
        this.user()
      },
      deep: true,
    },
  },
  mounted() {
    status.forms.list[0].selected = 1;
    this.user()
    /* eslint-disable-next-line camelcase */
    message.forms.list[0].selected = window.renaultRent.query_params?.request_type;
    /* eslint-disable-next-line camelcase */
    this.form.request_type = window.renaultRent.query_params?.request_type
  },
  methods: {
    updatedInputs(val) {
      this.form[val.name] = val.value
      this.$v.form[val.name].$touch()
    },
    updatedAgency(val) {
      this.form.business_id = val
      this.$v.form.business_id.$touch()
    },
    updatedDateInputs(val) {
      this.form[val.name][val.category] = val.value
      this.$v.form[val.name][val.category].$touch()
    },
    updatedSelecter(val) {
      if (val.name === 'status') {
        this.$store.commit('contact/SET_CONTACT_MODE', 2)
        return this.goToProPage(val.value)
      }
      this.form[val.name] = val.value
      this.$v.form[val.name].$touch()
    },
    updatedRadioButton(val) {
      this.form[val.name] = val.value
    },
    submitForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) return
      this.isLoading = true
      this.$store.dispatch('contact/POST_CONTACT', this.form)
      this.analytics()
    },
    goToProPage(val) {
      if (val !== '1' && !this.popinMode) {
        window.location = '/contact/professionnel'
      }
    },
    user() {
      if (!this.userDetails) return
      individual.forms.list[0].selected = this.userDetails?.civility
      this.form.civility = this.userDetails?.civility

      individual.forms.list[1].value = this.userDetails?.email
      this.form.email = this.userDetails?.email

      /* eslint-disable-next-line camelcase */
      individual.forms.list[2].value = this.userDetails?.last_name
      /* eslint-disable-next-line camelcase */
      this.form.last_name = this.userDetails?.last_name

      /* eslint-disable-next-line camelcase */
      individual.forms.list[3].value = this.userDetails?.first_name
      /* eslint-disable-next-line camelcase */
      this.form.first_name = this.userDetails?.first_name

      individual.forms.list[4].value = this.userDetails?.tel
      this.form.phone = this.userDetails?.tel

      /* eslint-disable-next-line camelcase */
      individual.forms.list[5].value = this.userDetails?.postal_code
      /* eslint-disable-next-line camelcase */
      this.form.postal_code = this.userDetails?.postal_code
    },
    analytics() {
      const type = parseInt(this.form.request_type, 10)
      const table = message.forms.list[0].list
      table.forEach((element) => {
        if (type === element.value) {
          this.request_value = element.label
        }
      })
      if (!window.dataLayer) {
        return
      }
      const event = 'contactRequest'
      const loginStatus = this.userIsLogged ? this.userIsLogged : 'N/A'
      const page = window.location.href
      const pageCategory = ''
      const pageTitle = document.querySelector('head title')?.text
      const formLocation = 'particulier'
      const requestType = this.request_value
      const payload = {
        event,
        loginStatus,
        page,
        pageCategory,
        pageTitle,
        formLocation,
        requestType,
      }
      window.dataLayer.push(payload)
    },
  },
}
</script>

<style lang="scss" scoped>

.contact-site {
  display: flex;
  //flex: 1;
  flex-direction: column;

  &__form {
    display: flex;
    flex: 1;
    flex-direction: column;

    @include teq-breakpoint($medium) {
      flex-direction: row;
    }

    &--popin {
      flex-direction: column;
    }

    &__row {
      display: flex;
      flex: 1;
      flex-direction: column;

      &:nth-child(1) {
        margin-right: 10px;
      }

      &:nth-child(2) {
        margin-left: 0;
        margin-right: 10px;

        @include teq-breakpoint($medium) {
          margin-left: 10px;
          margin-right: 0;
        }
      }
    }

    &__button {
      display: flex;
      flex: 1;
      flex-direction: column;
      margin: 30px 0;

      @include teq-breakpoint($medium) {
        flex-direction: row;
      }

      span {
        color: $black;
        margin-bottom: 30px;

        @include teq-breakpoint($medium) {
          margin-bottom: 0;
        }
      }

      li {
        display: flex;
        flex: 1;
      }
    }
  }
}
</style>
